import RoutePageTitle from "components/RoutePageTitle";
// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import CircularProgress from "@mui/material/CircularProgress";
// import { styled } from "@mui/material/styles";
// import Collapse from "@mui/material/Collapse";
// import IconButton from "@mui/material/IconButton";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import Button from "@mui/material/Button";
// import TextField from "@mui/material/TextField";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";

// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import { useUserContext } from "context/UserContext";

// // ================== TreeNode styles ==================
// const TreeNode = styled(Box)(({ theme, level = 0 }) => ({
//   display: "flex",
//   flexDirection: "column",
//   marginLeft: level * 16,
//   paddingLeft: 8,
//   borderLeft: "1px dashed",
//   borderColor: theme.palette.divider,
// }));

// const TreeNodeHeader = styled(Box)({
//   display: "flex",
//   alignItems: "center",
//   padding: "4px 0",
//   cursor: "pointer",
//   "&:hover": {
//     backgroundColor: "rgba(0, 0, 0, 0.04)",
//   },
// });

// // ================== WalletInfo ==================
// const WalletInfo = ({ wallet }) => {
//   if (!wallet) return null;
//   return (
//     <Box sx={{ ml: 2, mt: 1, p: 1, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
//       <Typography variant="body2">
//         <strong>Balance:</strong> {wallet.lsBalance} {wallet.lsCurrency}
//       </Typography>
//     </Box>
//   );
// };
// WalletInfo.propTypes = { wallet: PropTypes.object };

// // ================== Recursive Tree ==================
// const ThirdPartyTreeNode = ({ node, level = 0 }) => {
//   const [expanded, setExpanded] = useState(level < 2);

//   return (
//     <TreeNode level={level}>
//       <TreeNodeHeader onClick={() => setExpanded(!expanded)}>
//         <IconButton size="small" sx={{ mr: 1 }}>
//           {node.Children && node.Children.length > 0 ? (
//             expanded ? (
//               <ExpandMoreIcon fontSize="small" />
//             ) : (
//               <ChevronRightIcon fontSize="small" />
//             )
//           ) : null}
//         </IconButton>
//         <Box>
//           <Typography component="span" variant="body2" sx={{ fontWeight: level < 2 ? 500 : 400 }}>
//             {node.TierLabel ? `[${node.TierLabel}] ` : ""}
//             {node.Name}
//           </Typography>
//           {node.NameAlias && (
//             <Typography variant="caption" color="textSecondary" display="block">
//               {node.NameAlias}
//             </Typography>
//           )}
//         </Box>
//       </TreeNodeHeader>

//       <Collapse in={expanded}>
//         {node.Wallet && <WalletInfo wallet={node.Wallet} />}
//         {node.Children?.map((child) => (
//           <ThirdPartyTreeNode key={child.ID} node={child} level={level + 1} />
//         ))}
//       </Collapse>
//     </TreeNode>
//   );
// };
// ThirdPartyTreeNode.propTypes = {
//   node: PropTypes.object.isRequired,
//   level: PropTypes.number,
// };

// // ================== Main Page ==================
// function ManufacturerBK() {
//   const { userData, role } = useUserContext() || {};
//   const hierarchyDataRef = React.useRef(null);
//   const [flatNodes, setFlatNodes] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [reloadFlag, setReloadFlag] = useState(0);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [formData, setFormData] = useState({
//     name: "",
//     email: userData?.email,
//     parent: "",
//     tier_level: "",
//     client_email: "",
//     ref: "",
//     phone: "",
//     address: "",
//   });

//   const TIER_MAP = {
//     1: "GA層級",
//     2: "LA層級",
//     3: "Brand層級",
//     4: "Store層級",
//     5: "機器層級",
//     6: "機器上下倉層級",
//   };

//   const buildHierarchy = (items, parentId = null) => {
//     const parentIdStr = String(parentId || "");
//     return (items || [])
//       .filter((item) => String(item.parent || "") === parentIdStr)
//       .map((item) => ({
//         ID: item.id,
//         Name: item.name,
//         NameAlias: item.raw?.note_private || null,
//         Parent: item.parent || "",
//         Wallet: null,
//         Tier: item.tier,
//         TierLabel: TIER_MAP[item.tier] || "Unknown",
//         Children: buildHierarchy(items, item.id),
//       }));
//   };

//   const flattenHierarchy = (node) => {
//     let nodes = [{ ID: node.ID, Name: node.Name, Tier: node.Tier, TierLabel: node.TierLabel }];
//     node.Children?.forEach((child) => {
//       nodes = nodes.concat(flattenHierarchy(child));
//     });
//     return nodes;
//   };

//   // ---------- Fetch hierarchy ----------
//   useEffect(() => {
//     const fetchAndProcessHierarchy = async () => {
//       if (!userData?.email) {
//         setError("Email is required to fetch hierarchy data");
//         setIsLoading(false);
//         return;
//       }
//       setIsLoading(true);
//       setError(null);

//       try {
//         const apiUrl = `https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/mdm/tierlevel?email=${encodeURIComponent(
//           userData.email
//         )}`;
//         const mdmAuthToken = "57b2a9ba-4428-48e4-b137-f8337b68595e";

//         const response = await fetch(apiUrl, {
//           method: "GET",
//           headers: { "Mdm-Auth": mdmAuthToken },
//         });

//         if (!response.ok) throw new Error(`Server responded with status: ${response.status}`);
//         const result = await response.json();
//         if (result.code !== 200) throw new Error(result.message || "Error fetching hierarchy data");

//         const apiData = result.data;
//         if (!apiData || !apiData.root) throw new Error("No hierarchy data or root node found");

//         const allThirdParties = [
//           ...(apiData.ga || []),
//           ...(apiData.la || []),
//           ...(apiData.brand || []),
//           ...(apiData.shop || []),
//           ...(apiData.machine || []),
//           ...(apiData.machine_group || []),
//         ];

//         const root = apiData.root;
//         hierarchyDataRef.current = {
//           Username: root.name,
//           MatchedNode: {
//             ID: root.id,
//             Name: root.name,
//             NameAlias: root.raw?.note_private || null,
//             Parent: root.parent || "",
//             Wallet: null,
//             Tier: root.tier,
//             TierLabel: TIER_MAP[root.tier],
//             Children: buildHierarchy(allThirdParties, root.id),
//           },
//         };

//         setFlatNodes(flattenHierarchy(hierarchyDataRef.current.MatchedNode));
//       } catch (err) {
//         console.error("Error processing hierarchy:", err);
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (userData?.email) fetchAndProcessHierarchy();
//   }, [userData?.email, reloadFlag]); // ✅ 加上 reloadFlag 依賴

//   const hierarchyData = hierarchyDataRef.current;

//   // ---------- Form ----------
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "parent") {
//       const parentNode = flatNodes.find((n) => n.ID === value);
//       setFormData((prev) => ({
//         ...prev,
//         parent: value,
//         tier_level: parentNode ? String(parentNode.Tier + 1) : String(prev.tier_level),
//       }));
//     } else if (name === "tier_level") {
//       setFormData((prev) => ({
//         ...prev,
//         tier_level: String(value),
//         parent: flatNodes.find((n) => n.ID === prev.parent && n.Tier === Number(value) - 1)
//           ? prev.parent
//           : "",
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       if (!formData.name.trim()) {
//         alert("名稱必填");
//         return;
//       }
//       if (!formData.tier_level) {
//         alert("層級必填");
//         return;
//       }
//       if (!formData.parent) {
//         alert("父節點必填");
//         return;
//       }

//       const apiUrl =
//         "https://crm-mqtt-718408119422.asia-east1.run.app/api/v1/mdm/thirdparty/create";
//       const mdmAuthToken = "57b2a9ba-4428-48e4-b137-f8337b68595e";

//       const payload = {
//         ...formData,
//         parent: parseInt(formData.parent, 10),
//       };

//       const res = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Mdm-Auth": mdmAuthToken,
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await res.json();
//       if (result.code !== 200) throw new Error(result.message || "Create failed");

//       // 成功後關閉 Dialog 並刷新 hierarchy
//       setOpenDialog(false);
//       setFormData({
//         name: "",
//         email: userData?.email,
//         parent: "",
//         tier_level: "",
//         client_email: "",
//         ref: "",
//         phone: "",
//         address: "",
//       });

//       setReloadFlag((f) => f + 1); // ✅ 觸發刷新
//     } catch (err) {
//       alert("錯誤: " + err.message);
//     }
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//               >
//                 <MDTypography variant="h6" color="white">
//                   {role === "SP" ? "Manufacturer" : "廠商"}
//                 </MDTypography>
//                 <Button
//                   variant="contained"
//                   onClick={() => setOpenDialog(true)}
//                   sx={{
//                     backgroundColor: "#FF9800",
//                     color: "#FFFFFF",
//                     "&:hover": { backgroundColor: "#FB8C00" },
//                   }}
//                 >
//                   創建廠商
//                 </Button>
//               </MDBox>
//               <MDBox p={3}>
//                 {isLoading ? (
//                   <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
//                     <CircularProgress />
//                   </Box>
//                 ) : error ? (
//                   <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
//                     <Typography color="error">{error}</Typography>
//                   </Box>
//                 ) : !hierarchyData?.MatchedNode ? (
//                   <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
//                     <Typography>No hierarchy data found</Typography>
//                   </Box>
//                 ) : (
//                   <Box sx={{ maxHeight: "70vh", overflow: "auto", p: 1 }}>
//                     <ThirdPartyTreeNode node={hierarchyData.MatchedNode} />
//                   </Box>
//                 )}
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>

//       {/* ===== Create Dialog ===== */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>創建廠商</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="名稱"
//             name="name"
//             fullWidth
//             margin="normal"
//             required
//             value={formData.name}
//             onChange={handleChange}
//           />
//           <TextField
//             select
//             label="層級"
//             name="tier_level"
//             fullWidth
//             margin="normal"
//             required
//             value={formData.tier_level}
//             onChange={handleChange}
//             SelectProps={{ native: true }}
//           >
//             <option value=""></option>
//             {Object.entries(TIER_MAP)
//               .filter(([key]) => Number(key) === 2 || Number(key) === 3)
//               .map(([key, label]) => (
//                 <option key={key} value={key}>
//                   {label}
//                 </option>
//               ))}
//           </TextField>
//           <TextField
//             select
//             label="父節點"
//             name="parent"
//             fullWidth
//             margin="normal"
//             required
//             value={formData.parent}
//             onChange={handleChange}
//             SelectProps={{ native: true }}
//           >
//             <option value=""></option>
//             {flatNodes
//               .filter((n) => n.Tier === Number(formData.tier_level) - 1)
//               .map((node) => (
//                 <option key={node.ID} value={node.ID}>
//                   {node.Name} [{node.TierLabel}]
//                 </option>
//               ))}
//           </TextField>
//           <TextField
//             label="客戶信箱"
//             name="client_email"
//             fullWidth
//             margin="normal"
//             value={formData.client_email}
//             onChange={handleChange}
//           />
//           <TextField
//             label="識別碼"
//             name="ref"
//             fullWidth
//             margin="normal"
//             value={formData.ref}
//             onChange={handleChange}
//           />
//           <TextField
//             label="手機"
//             name="phone"
//             fullWidth
//             margin="normal"
//             value={formData.phone}
//             onChange={handleChange}
//           />
//           <TextField
//             label="地址"
//             name="address"
//             fullWidth
//             margin="normal"
//             value={formData.address}
//             onChange={handleChange}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDialog(false)}>取消</Button>
//           <Button
//             onClick={handleSubmit}
//             sx={{ mt: 2, mb: 2, color: "white !important" }}
//             variant="contained"
//             disabled={!formData.name.trim() || !formData.tier_level || !formData.parent}
//           >
//             送出
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </DashboardLayout>
//   );
// }

// export default ManufacturerBK;

import React, { useState, useEffect, useMemo, useCallback } from "react";
import PropTypes from "prop-types";

// MUI components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import * as XLSX from "xlsx";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

// Layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useUserContext } from "context/UserContext";
import { useTranslation } from "react-i18next";
import getGraphQLEndpoint from "utils/getGraphQLEndpoint";

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");
const stripGraphQLSuffix = (value) => value.replace(/\/GraphQLHandler$/, "");
const buildBackendBase = (graphqlEndpoint) =>
  trimTrailingSlash(stripGraphQLSuffix(graphqlEndpoint || ""));
const resolveBackendBase = (graphqlEndpoint) => {
  const base = buildBackendBase(graphqlEndpoint);
  const fallback = typeof window !== "undefined" ? window.location.origin : "";
  if (!base || base === "undefined" || base === "null") return fallback;
  try {
    new URL(base);
    return base;
  } catch (error) {
    return fallback || base;
  }
};

const buildApiUrl = (base, path, params = {}) => {
  const url = new URL(path, base);
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    url.searchParams.set(key, value);
  });
  return url.toString();
};

const fetchJson = async (url, options = {}) => {
  const res = await fetch(url, options);
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    const extra = text ? ` ${text}` : "";
    throw new Error(`Request failed (${res.status})${extra}`);
  }
  return res.json();
};

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const textFieldSx = {
  "& .MuiInputLabel-root": {
    fontSize: "0.7rem",
  },
  "& .MuiInputBase-input": {
    fontSize: "0.8rem",
  },
  "& .MuiInputLabel-shrink": {
    fontSize: "0.9rem",
  },
  "& .MuiInputBase-input::placeholder": {
    fontSize: "0.95rem",
    opacity: 1,
  },
};

const ManufacturerEditCell = ({ row, onOpen, label }) => (
  <Button
    size="small"
    variant="outlined"
    onClick={() => onOpen(row.original)}
    sx={{
      borderRadius: "12px",
      borderColor: "#1A73E8",
      color: "#1A73E8",
      fontWeight: 600,
      px: 3,
      "&:hover": {
        borderColor: "#1669D3",
        backgroundColor: "rgba(26, 115, 232, 0.08)",
      },
    }}
  >
    {label}
  </Button>
);

ManufacturerEditCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object.isRequired,
  }).isRequired,
  onOpen: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

const ManufacturerEditCellRenderer = ({ row }) => {
  const onOpen = row?.original?.onEdit;
  if (!onOpen) return null;
  return <ManufacturerEditCell row={row} onOpen={onOpen} label="編輯" />;
};

ManufacturerEditCellRenderer.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object.isRequired,
  }).isRequired,
};

function Manufacturer() {
  const { userData } = useUserContext() || {};
  const { t } = useTranslation("common");
  const backendUrl = useMemo(getGraphQLEndpoint, []);
  const apiBase = useMemo(() => resolveBackendBase(backendUrl), [backendUrl]);
  const normalizeEmail = useCallback(
    (value) => (value ? String(value).trim().toLowerCase() : ""),
    []
  );
  const [flatNodes, setFlatNodes] = useState([]);
  const [manufacturerRows, setManufacturerRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadFlag, setReloadFlag] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState("csv");
  const [updateForm, setUpdateForm] = useState({
    third_party_id: "",
    email: normalizeEmail(userData?.email),
    name_alias: "",
    vendor_email: "",
    name: "",
    ref: "",
    phone: "",
    zip_code: "",
    city: "",
    address: "",
    note_private: "",
  });
  const [updateError, setUpdateError] = useState("");
  const [updateSuccess, setUpdateSuccess] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: normalizeEmail(userData?.email),
    parent: "",
    tier_level: "",
    client_email: "",
    ref: "",
    phone: "",
    zip_code: "",
    city: "",
    address: "",
    name_alias: "",
    company_name: "",
    u_b_c: "",
    transaction_currency: "",
    company_owner: "",
    note_private: "",
  });

  const TIER_MAP = {
    1: "GA層級",
    2: "LA層級",
    3: "Brand層級",
    4: "Store層級",
    5: "機器層級",
    6: "機器上下倉層級",
  };

  const parseMaybeJSON = (value) => {
    if (typeof value !== "string") return value;
    try {
      return JSON.parse(value);
    } catch (err) {
      console.warn("Failed to parse hierarchy field", err);
      return value;
    }
  };

  const firstNonEmpty = (...values) => {
    for (const value of values) {
      if (value === undefined || value === null) continue;
      const text = String(value).trim();
      if (text) return text;
    }
    return "";
  };

  const normalizeArrayField = (value) => {
    const parsed = parseMaybeJSON(value);
    return Array.isArray(parsed) ? parsed : [];
  };

  const fetchGraphQL = useCallback(
    async (query, variables) => {
      const queryText = typeof query === "string" ? query : String(query || "");
      if (!queryText.trim()) {
        throw new Error("GraphQL query is empty");
      }
      const headers = { "Content-Type": "application/json", Accept: "application/json" };
      const response = await fetch(backendUrl, {
        method: "POST",
        headers,
        body: JSON.stringify({ query: queryText, variables: variables ?? {} }),
      });

      if (!response.ok) {
        const raw = await response.text();
        let detail = raw;
        try {
          const parsed = JSON.parse(raw);
          if (parsed?.errors?.length) {
            detail = parsed.errors[0]?.message || raw;
          } else if (parsed?.error) {
            detail = parsed.error;
          } else {
            detail = raw;
          }
        } catch (err) {
          detail = raw;
        }
        throw new Error(
          `GraphQL request failed: ${response.status}${detail ? ` - ${detail}` : ""}`
        );
      }

      const json = await response.json();
      if (json.errors?.length) {
        throw new Error(json.errors[0]?.message || "GraphQL error");
      }
      return json;
    },
    [backendUrl]
  );

  const buildTableRows = (items) => {
    const flattenedData = (items || [])
      .filter((item) => [1, 2, 3].includes(Number(item?.tier)))
      .map((item) => ({
        id: String(item?.id ?? ""),
        ref: firstNonEmpty(item?.raw?.ref, item?.ref),
        name: item?.name ?? "",
        email: item?.email ?? "",
        tier: TIER_MAP[item?.tier] || item?.tier || "",
        parent: item?.parent ?? "",
        name_alias: firstNonEmpty(item?.name_alias, item?.raw?.note_private),
        phone: item?.phone ?? "",
        zip_code: item?.zip_code ?? "",
        city: item?.city ?? "",
        address: item?.address ?? "",
        note_private: item?.note_private ?? "",
        vendor_email: item?.vendor_email ?? "",
      }));

    return flattenedData.sort((a, b) => {
      const tierA = Object.keys(TIER_MAP).find((key) => TIER_MAP[key] === a.tier) || a.tier;
      const tierB = Object.keys(TIER_MAP).find((key) => TIER_MAP[key] === b.tier) || b.tier;
      if (tierA !== tierB) return Number(tierA) - Number(tierB);
      return String(a.id).localeCompare(String(b.id));
    });
  };

  // Build hierarchy (same as original)
  const buildHierarchy = (items, parentId = null) => {
    const parentIdStr = String(parentId || "");
    return (items || [])
      .filter((item) => String(item.parent || "") === parentIdStr)
      .map((item) => ({
        ID: item.id,
        Name: item.name,
        NameAlias: firstNonEmpty(item?.name_alias, item?.raw?.note_private) || null,
        Parent: item.parent || "",
        Wallet: null,
        Tier: item.tier,
        TierLabel: TIER_MAP[item.tier] || "Unknown",
        Children: buildHierarchy(items, item.id),
      }));
  };

  // Flatten hierarchy for parent dropdown
  const flattenHierarchy = (node) => {
    let nodes = [{ ID: node.ID, Name: node.Name, Tier: node.Tier, TierLabel: node.TierLabel }];
    node.Children?.forEach((child) => {
      nodes = nodes.concat(flattenHierarchy(child));
    });
    return nodes;
  };

  // Fetch hierarchy data
  useEffect(() => {
    const fetchAndProcessHierarchy = async () => {
      if (!userData?.email) {
        setError("Email is required to fetch hierarchy data");
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      setError(null);

      try {
        const graphqlResult = await fetchGraphQL(
          `
            query GetMdmTierLevel($email: String!) {
              GetMdmTierLevel(email: $email)
            }
          `,
          { email: normalizeEmail(userData.email) }
        );
        const result = graphqlResult?.data?.GetMdmTierLevel;
        if (!result) throw new Error("Empty response from tier level API");
        if (result.code !== 200) throw new Error(result.message || "Error fetching hierarchy data");

        const apiData = parseMaybeJSON(result.data) || {};
        const rootCandidate = parseMaybeJSON(apiData.root);
        const ga = normalizeArrayField(apiData.ga);
        const la = normalizeArrayField(apiData.la);
        const brand = normalizeArrayField(apiData.brand);
        const shop = normalizeArrayField(apiData.shop);
        const machine = normalizeArrayField(apiData.machine);
        const machineGroup = normalizeArrayField(apiData.machine_group);

        const allThirdParties = [...ga, ...la, ...brand, ...shop, ...machine, ...machineGroup];
        const nodesById = new Map(
          allThirdParties.map((node) => [String(node?.id ?? node?.ref ?? ""), node])
        );

        let root = typeof rootCandidate === "object" ? rootCandidate : null;
        if (!root) {
          root = allThirdParties.find((node) => {
            const parentValue = node?.parent;
            if (!parentValue || parentValue === "0" || parentValue === 0) return true;
            return !nodesById.has(String(parentValue));
          });
        }

        if (!root) throw new Error("No hierarchy data or root node found");
        const hierarchyData = {
          Username: root.name,
          MatchedNode: {
            ID: root.id,
            Name: root.name,
            NameAlias: firstNonEmpty(root?.name_alias, root?.raw?.note_private) || null,
            Parent: root.parent || "",
            Wallet: null,
            Tier: root.tier,
            TierLabel: TIER_MAP[root.tier],
            Children: buildHierarchy(allThirdParties, root.id),
          },
        };

        setFlatNodes(flattenHierarchy(hierarchyData.MatchedNode));
        setManufacturerRows(buildTableRows(allThirdParties));
      } catch (err) {
        console.error("Error processing hierarchy:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (userData?.email) fetchAndProcessHierarchy();
  }, [userData?.email, reloadFlag, fetchGraphQL]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "parent") {
      const parentNode = flatNodes.find((n) => n.ID === value);
      setFormData((prev) => ({
        ...prev,
        parent: value,
        tier_level: parentNode ? String(parentNode.Tier + 1) : String(prev.tier_level),
      }));
    } else if (name === "tier_level") {
      setFormData((prev) => ({
        ...prev,
        tier_level: String(value),
        parent: flatNodes.find((n) => n.ID === prev.parent && n.Tier === Number(value) - 1)
          ? prev.parent
          : "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      if (!formData.name.trim()) {
        alert("名稱必填");
        return;
      }
      if (!formData.tier_level) {
        alert("層級必填");
        return;
      }
      if (!formData.parent) {
        alert("父節點必填");
        return;
      }
      if (!formData.company_name.trim()) {
        alert("公司名稱必填");
        return;
      }
      if (!formData.u_b_c.trim()) {
        alert("統一編號必填");
        return;
      }
      if (!formData.transaction_currency.trim()) {
        alert("交易幣別必填");
        return;
      }
      if (!formData.company_owner.trim()) {
        alert("公司負責人必填");
        return;
      }

      const { company_name, u_b_c, transaction_currency, company_owner, name_alias, ...rest } =
        formData;
      const trimmedCompanyName = company_name.trim();
      const trimmedUBC = u_b_c.trim();
      const trimmedTransactionCurrency = transaction_currency.trim();
      const trimmedCompanyOwner = company_owner.trim();
      const trimmedNameAlias = (name_alias || "").trim();

      const payload = {
        ...rest,
        parent: parseInt(rest.parent, 10),
        name_alias: trimmedNameAlias,
        array_options: {
          options_tier_level: String(rest.tier_level || ""),
          options_company_name: trimmedCompanyName,
          options_u_b_c: trimmedUBC,
          options_transaction_currency: trimmedTransactionCurrency,
          options_company_owner: trimmedCompanyOwner,
        },
      };
      payload.email = normalizeEmail(rest.email);
      payload.client_email = normalizeEmail(rest.client_email);

      const graphqlResult = await fetchGraphQL(
        `
          mutation CreateMdmThirdParty($input: JSON!) {
            CreateMdmThirdParty(input: $input)
          }
        `,
        { input: payload }
      );
      const result = graphqlResult?.data?.CreateMdmThirdParty;
      if (!result) throw new Error("Empty response from create API");
      if (result.code !== 200) throw new Error(result.message || "Create failed");

      // Success: Close dialog, reset form, and trigger refresh
      setOpenDialog(false);
      setFormData({
        name: "",
        email: normalizeEmail(userData?.email),
        parent: "",
        tier_level: "",
        client_email: "",
        ref: "",
        phone: "",
        zip_code: "",
        city: "",
        address: "",
        name_alias: "",
        company_name: "",
        u_b_c: "",
        transaction_currency: "",
        company_owner: "",
        note_private: "",
      });
      setReloadFlag((f) => f + 1); // Trigger hierarchy refresh
    } catch (err) {
      alert("錯誤: " + err.message);
    }
  };

  const handleOpenUpdate = useCallback(
    (row) => {
      if (!row) return;
      setUpdateForm({
        third_party_id: row.id ?? "",
        email: normalizeEmail(row?.email),
        name_alias: row.name_alias ?? "",
        vendor_email: "",
        name: row.name ?? "",
        ref: row.ref ?? "",
        phone: row.phone ?? "",
        zip_code: row.zip_code ?? "",
        city: row.city ?? "",
        address: row.address ?? "",
        note_private: row.note_private ?? "",
      });
      setUpdateError("");
      setUpdateOpen(true);
    },
    [normalizeEmail, userData?.email]
  );

  const handleUpdateChange = useCallback(
    (key, value) => {
      setUpdateForm((prev) => ({ ...prev, [key]: value }));
      if (updateError) setUpdateError("");
    },
    [updateError]
  );

  const handleUpdateSubmit = useCallback(async () => {
    const email = normalizeEmail(userData?.email);
    const nameAlias = (updateForm.name_alias || "").trim();
    const thirdPartyId = Number(updateForm.third_party_id);

    if (!thirdPartyId) {
      setUpdateError("缺少 third_party_id");
      return;
    }
    if (!email) {
      setUpdateError("信箱必填");
      return;
    }
    if (!nameAlias) {
      setUpdateError("暱稱必填");
      return;
    }

    try {
      const payload = {
        third_party_id: thirdPartyId,
        email,
        name_alias: nameAlias,
        vendor_email: normalizeEmail(updateForm.vendor_email),
        name: (updateForm.name || "").trim(),
        ref: (updateForm.ref || "").trim(),
        phone: (updateForm.phone || "").trim(),
        zip_code: (updateForm.zip_code || "").trim(),
        city: (updateForm.city || "").trim(),
        address: (updateForm.address || "").trim(),
        note_private: (updateForm.note_private || "").trim(),
      };

      const result = await fetchJson(buildApiUrl(apiBase, "/api/v1/mdm/thirdparty/updatev2"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (result?.code && result.code !== 200) {
        throw new Error(result.message || "Update failed");
      }

      setUpdateOpen(false);
      setReloadFlag((f) => f + 1);
      if (result?.code === 200) {
        setUpdateSuccess("success");
      }
    } catch (err) {
      setUpdateError(err.message || "更新失敗");
    }
  }, [apiBase, normalizeEmail, updateForm, userData?.email]);

  const manufacturerColumns = useMemo(
    () => [
      { Header: "名稱", accessor: "name" },
      { Header: "暱稱", accessor: "name_alias" },
      { Header: "使用者登入帳號", accessor: "email" },
      { Header: "電話", accessor: "phone" },
      { Header: "品牌信箱窗口", accessor: "vendor_email" },
      { Header: "郵遞區號", accessor: "zip_code" },
      { Header: "城市", accessor: "city" },
      { Header: "地址", accessor: "address" },
      { Header: "父ID", accessor: "parent" },
      { Header: "識別代碼", accessor: "id" },
      { Header: "參考代碼", accessor: "ref" },
      { Header: "內部註解", accessor: "note_private" },
      {
        Header: "操作",
        accessor: "actions",
        Cell: ManufacturerEditCellRenderer,
      },
    ],
    []
  );

  const tableData = useMemo(() => {
    // console.log(manufacturerRows);

    return {
      columns: manufacturerColumns,
      rows: manufacturerRows.map((row) => ({ ...row, onEdit: handleOpenUpdate })),
    };
  }, [manufacturerColumns, manufacturerRows, handleOpenUpdate]);

  const exportColumns = useMemo(
    () =>
      manufacturerColumns
        .filter((column) => column.accessor !== "actions")
        .map((column) => ({
          header: column.Header,
          accessor: column.accessor,
        })),
    [manufacturerColumns]
  );

  const handleDownload = useCallback(() => {
    try {
      const headers = exportColumns.map((column) => column.header);
      const bodyRows = manufacturerRows.map((row) =>
        exportColumns.map((column) => {
          const value = row?.[column.accessor];
          if (value === null || value === undefined) return "";
          if (typeof value === "object") return JSON.stringify(value);
          return value;
        })
      );

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...bodyRows]);

      if (downloadFormat === "xlsx") {
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Manufacturer");
        XLSX.writeFile(workbook, "manufacturer.xlsx");
      } else {
        const csv = `\uFEFF${XLSX.utils.sheet_to_csv(worksheet)}`;
        downloadBlob(new Blob([csv], { type: "text/csv;charset=utf-8;" }), "manufacturer.csv");
      }

      setDownloadDialogOpen(false);
    } catch (err) {
      console.error(err);
      setError("下載失敗");
    }
  }, [downloadFormat, exportColumns, manufacturerRows]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  <RoutePageTitle />
                </MDTypography>
                <MDBox display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                  <Button
                    id="download"
                    variant="outlined"
                    onClick={() => {
                      setDownloadFormat("csv");
                      setDownloadDialogOpen(true);
                    }}
                    sx={{
                      borderRadius: "12px",
                      borderColor: "#FFFFFF",
                      color: "#FFFFFF",
                      fontWeight: 600,
                      "&:hover": {
                        borderColor: "#FFFFFF",
                        backgroundColor: "rgba(255,255,255,0.15)",
                      },
                    }}
                  >
                    匯出表格
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => setOpenDialog(true)}
                    sx={{
                      backgroundColor: "#FF9800",
                      color: "#FFFFFF",
                      "&:hover": { backgroundColor: "#FB8C00" },
                    }}
                  >
                    {t("actions.createManufacturer")}
                  </Button>
                </MDBox>
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                {isLoading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="300px"
                  >
                    <CircularProgress />
                  </MDBox>
                ) : (
                  <>
                    {error && (
                      <MDBox
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minHeight="80px"
                      >
                        <Typography color="error">{error}</Typography>
                      </MDBox>
                    )}
                    <DataTable
                      table={tableData}
                      entriesPerPage={{ defaultValue: 10, entries: [10, 25, 50] }}
                      canSearch
                      showTotalEntries={false}
                      isSorted
                      noEndBorder
                    />
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog
        open={downloadDialogOpen}
        onClose={() => setDownloadDialogOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>匯出表格</DialogTitle>
        <DialogContent dividers>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              value={downloadFormat}
              onChange={(event) => setDownloadFormat(event.target.value)}
            >
              <FormControlLabel value="csv" control={<Radio />} label="CSV" />
              <FormControlLabel value="xlsx" control={<Radio />} label="XLSX" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setDownloadDialogOpen(false)}
            sx={{
              borderRadius: "10px",
              borderColor: "#1A73E8",
              color: "#1A73E8",
              fontWeight: 600,
              "&:hover": {
                borderColor: "#1557B0",
                backgroundColor: "rgba(26, 115, 232, 0.08)",
              },
            }}
          >
            取消
          </Button>
          <Button
            variant="contained"
            onClick={handleDownload}
            sx={{
              borderRadius: "10px",
              backgroundColor: "#1A73E8",
              color: "#FFFFFF",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1557B0",
              },
            }}
          >
            確認下載
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Manufacturer Dialog */}
      <Dialog
        open={updateOpen}
        onClose={() => {
          setUpdateOpen(false);
          setUpdateError("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>編輯廠商資訊</DialogTitle>
        <DialogContent>
          {updateError && (
            <Typography color="error" sx={{ mt: 1 }}>
              {updateError}
            </Typography>
          )}
          <TextField
            label="third_party_id"
            name="third_party_id"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.third_party_id}
            disabled
          />
          <TextField
            label="信箱"
            name="email"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={updateForm.email}
            onChange={(event) => handleUpdateChange("email", event.target.value)}
            disabled
          />
          <TextField
            label="暱稱"
            name="name_alias"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={updateForm.name_alias}
            onChange={(event) => handleUpdateChange("name_alias", event.target.value)}
          />
          <TextField
            label="客戶名稱"
            name="name"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.name}
            onChange={(event) => handleUpdateChange("name", event.target.value)}
          />
          <TextField
            label="自訂識別碼"
            name="ref"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.ref}
            disabled
            onChange={(event) => handleUpdateChange("ref", event.target.value)}
          />
          <TextField
            label="客戶電話"
            name="phone"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.phone}
            onChange={(event) => handleUpdateChange("phone", event.target.value)}
          />
          <TextField
            label="品牌信箱窗口"
            name="vendor_email"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.vendor_email}
            onChange={(event) => handleUpdateChange("vendor_email", event.target.value)}
          />
          <TextField
            label="郵遞區號"
            name="zip_code"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.zip_code}
            onChange={(event) => handleUpdateChange("zip_code", event.target.value)}
          />
          <TextField
            label="城市"
            name="city"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.city}
            onChange={(event) => handleUpdateChange("city", event.target.value)}
          />
          <TextField
            label="客戶地址"
            name="address"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.address}
            onChange={(event) => handleUpdateChange("address", event.target.value)}
          />
          <TextField
            label="內部註解"
            name="note_private"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={updateForm.note_private}
            onChange={(event) => handleUpdateChange("note_private", event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setUpdateOpen(false);
              setUpdateError("");
            }}
          >
            取消
          </Button>
          <Button
            onClick={handleUpdateSubmit}
            variant="outlined"
            sx={{
              borderRadius: "999px",
              borderColor: "#1A73E8",
              color: "#1A73E8",
              fontWeight: 600,
              px: 4,
              "&:hover": {
                borderColor: "#1669D3",
                backgroundColor: "rgba(26, 115, 232, 0.08)",
              },
            }}
          >
            更新
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={Boolean(updateSuccess)}
        autoHideDuration={3000}
        onClose={() => setUpdateSuccess("")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setUpdateSuccess("")}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {updateSuccess}
        </Alert>
      </Snackbar>

      {/* Create Manufacturer Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{t("actions.createManufacturer")}</DialogTitle>
        <DialogContent>
          <TextField
            label="名稱"
            name="name"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={formData.name}
            onChange={handleChange}
          />
          <TextField
            select
            label="層級"
            name="tier_level"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={formData.tier_level}
            onChange={handleChange}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {Object.entries(TIER_MAP)
              .filter(([key]) => {
                const tierLevel = Number(key);
                return tierLevel >= 2 && tierLevel <= 4;
              })
              .map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
          </TextField>
          <TextField
            select
            label="父節點"
            name="parent"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={formData.parent}
            onChange={handleChange}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {flatNodes
              .filter((n) => n.Tier === Number(formData.tier_level) - 1)
              .map((node) => (
                <option key={node.ID} value={node.ID}>
                  {node.Name} [{node.TierLabel}]
                </option>
              ))}
          </TextField>
          <TextField
            label="客戶信箱"
            name="client_email"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.client_email}
            onChange={handleChange}
          />
          <TextField
            label="識別碼"
            name="ref"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.ref}
            onChange={handleChange}
          />
          <TextField
            label="手機"
            name="phone"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.phone}
            onChange={handleChange}
          />
          <TextField
            label="郵遞區號"
            name="zip_code"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.zip_code}
            onChange={handleChange}
          />
          <TextField
            label="城市"
            name="city"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.city}
            onChange={handleChange}
          />
          <TextField
            label="地址"
            name="address"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.address}
            onChange={handleChange}
          />
          <TextField
            label="暱稱"
            name="name_alias"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.name_alias}
            onChange={handleChange}
          />
          <TextField
            label="公司名稱"
            name="company_name"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={formData.company_name}
            onChange={handleChange}
          />
          <TextField
            label="統一編號"
            name="u_b_c"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={formData.u_b_c}
            onChange={handleChange}
          />
          <TextField
            label="交易幣別"
            name="transaction_currency"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={formData.transaction_currency}
            onChange={handleChange}
          />
          <TextField
            label="公司負責人"
            name="company_owner"
            fullWidth
            margin="normal"
            required
            sx={textFieldSx}
            value={formData.company_owner}
            onChange={handleChange}
          />
          <TextField
            label="內部備註"
            name="note_private"
            fullWidth
            margin="normal"
            sx={textFieldSx}
            value={formData.note_private}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>取消</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ color: "white !important" }}
            disabled={
              !formData.name.trim() ||
              !formData.tier_level ||
              // !formData.parent ||
              !formData.company_name.trim() ||
              !formData.u_b_c.trim() ||
              !formData.transaction_currency.trim() ||
              !formData.company_owner.trim()
            }
          >
            送出
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Manufacturer;
